/* WESN - BOGO Weekend: countdowns + cart nudge. Config comes from snippets/bogo-head.liquid (window.BOGO).
   Countdown fills [data-bogo-countdown] (compact "1d 14h 05m 09s") and [data-bogo-d/h/m/s] (segmented digits).
   When the end time passes, <html> gets .bogo-over and the sale bits hide themselves.
   Cart nudge: reads /cart.js and writes one line into the UpCart drawer (open shadow root), the theme's own drawer and
   the cart page - odd item count > "add one more, it's free", even > "free item unlocked". Same mustard box as the product page. */
(function () {
  'use strict';
  var cfg = window.BOGO || {};
  var doc = document;
  var end = cfg.ends ? new Date(cfg.ends) : null;
  var over = false;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function q(sel, root) { return [].slice.call((root || doc).querySelectorAll(sel)); }
  function countdowns() {
    var list = q('[data-bogo-countdown]');
    var up = doc.getElementById('upCart');
    if (up && up.shadowRoot) list = list.concat(q('[data-bogo-countdown]', up.shadowRoot));
    return list;
  }

  /* ---------- countdown ---------- */
  function tick() {
    if (!end || isNaN(end.getTime())) return;
    var diff = end.getTime() - Date.now();
    if (diff <= 0) {
      if (!over) {
        over = true;
        doc.documentElement.classList.add('bogo-over');
        countdowns().forEach(function (el) { el.textContent = cfg.overText || 'Ended'; });
        q('[data-bogo-timer]').forEach(function (el) { el.style.display = 'none'; });
        refreshNudges();
      }
      return;
    }
    var d = Math.floor(diff / 864e5), h = Math.floor(diff % 864e5 / 36e5), m = Math.floor(diff % 36e5 / 6e4), s = Math.floor(diff % 6e4 / 1e3);
    var compact = (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    countdowns().forEach(function (el) { el.textContent = compact; });
    q('[data-bogo-d]').forEach(function (el) { el.textContent = pad(d); });
    q('[data-bogo-h]').forEach(function (el) { el.textContent = pad(h); });
    q('[data-bogo-m]').forEach(function (el) { el.textContent = pad(m); });
    q('[data-bogo-s]').forEach(function (el) { el.textContent = pad(s); });
  }
  tick();
  setInterval(tick, 1000);

  /* ---------- cart nudge ---------- */
  var NUDGE_CSS = '.bogo-nudge{margin:0 0 14px;background:#e1962d;color:#151515;padding:14px 16px 15px;font:400 12.5px/1.55 t26-carbon,"Courier New",monospace;letter-spacing:.01em;text-transform:none;text-align:left}.bogo-nudge__head{display:flex;justify-content:space-between;align-items:baseline;gap:6px 14px;flex-wrap:wrap;margin:0 0 8px}.bogo-nudge__eyebrow{font:400 10.5px/1.3 t26-carbon,"Courier New",monospace;letter-spacing:.14em;text-transform:uppercase;color:#151515;opacity:.8}.bogo-nudge__meta{font:400 10.5px/1.3 t26-carbon,"Courier New",monospace;letter-spacing:.12em;text-transform:uppercase;color:rgba(21,21,21,.7);white-space:nowrap;font-variant-numeric:tabular-nums}.bogo-nudge__meta b{font-weight:400;color:#151515}.bogo-nudge__title{display:block;font:500 26px/.95 transducer-condensed,"Arial Narrow",sans-serif;letter-spacing:-.01em;text-transform:uppercase;color:#151515;margin:0 0 7px}#CartPopup .bogo-nudge__title,#upCart .bogo-nudge__title,.bogo-nudge .bogo-nudge__title{font-family:transducer-condensed,"Arial Narrow",sans-serif!important}.bogo-nudge__text{display:block;color:rgba(21,21,21,.85)}';
  var count = null, pending = null;

  function message(n) {
    if (n <= 0) return { title: cfg.cartEmptyTitle || 'Buy one, get one free', text: cfg.cartEmpty || 'Every second item in your cart is free.', cls: '' };
    if (n % 2 === 1) return { title: cfg.cartOddTitle || 'Add one more, it’s free', text: cfg.cartOdd || 'Your next item costs nothing. Applied at checkout.', cls: '' };
    return { title: cfg.cartEvenTitle || 'Free item unlocked', text: cfg.cartEven || 'Your lowest-priced item comes off at checkout.', cls: 'bogo-nudge--unlocked' };
  }

  function paint(container, before) {
    if (!container) return;
    var el = container.querySelector(':scope > .bogo-nudge');
    if (over || count === null) { if (el) el.remove(); return; }
    var m = message(count);
    if (!el) {
      el = doc.createElement('div');
      el.className = 'bogo-nudge';
      el.setAttribute('role', 'status');
      el.innerHTML = '<span class="bogo-nudge__head"><span class="bogo-nudge__eyebrow"></span><span class="bogo-nudge__meta"><span class="bogo-nudge__meta-label"></span> <b data-bogo-countdown>&nbsp;</b></span></span><strong class="bogo-nudge__title"></strong><span class="bogo-nudge__text"></span>';
      el.querySelector('.bogo-nudge__eyebrow').textContent = cfg.eyebrow || 'This weekend only';
      el.querySelector('.bogo-nudge__meta-label').textContent = cfg.meta || 'Ends in';
      container.insertBefore(el, before && before.parentNode === container ? before : container.firstChild);
      tick();
    }
    el.className = 'bogo-nudge ' + m.cls;
    el.querySelector('.bogo-nudge__title').textContent = m.title;
    el.querySelector('.bogo-nudge__text').textContent = m.text;
  }

  function paintAll() {
    /* UpCart (open shadow root) */
    var up = doc.getElementById('upCart');
    var root = up && up.shadowRoot;
    if (root) {
      if (!root.querySelector('style[data-bogo]')) { var st = doc.createElement('style'); st.setAttribute('data-bogo', ''); st.textContent = NUDGE_CSS; root.appendChild(st); }
      var body = root.querySelector('.upcart-public-cart-body, .upcart-cart-body');
      if (body) paint(body, body.firstElementChild);
    }
    /* theme drawer + cart page */
    paint(doc.getElementById('drawer-cart-content'));
    var page = doc.querySelector('.section-main-cart .wrap, .main-cart .wrap, .section-main-cart');
    if (page) paint(page);
  }

  function refreshNudges() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { count = c && typeof c.item_count === 'number' ? c.item_count : 0; paintAll(); })
        .catch(function () {});
    }, 180);
  }

  /* re-paint when the drawers re-render */
  var painting = false;
  function watch(node) {
    if (!node || node.__bogoWatched || !('MutationObserver' in window)) return;
    node.__bogoWatched = true;
    new MutationObserver(function () {
      if (painting) return;
      painting = true;
      requestAnimationFrame(function () { paintAll(); painting = false; });
    }).observe(node, { childList: true, subtree: true });
  }
  function hookUpCart() {
    var up = doc.getElementById('upCart');
    if (up && up.shadowRoot) { watch(up.shadowRoot); return true; }
    return false;
  }
  if (!hookUpCart()) {
    var tries = 0, t = setInterval(function () { if (hookUpCart() || ++tries > 60) clearInterval(t); }, 500);
  }
  watch(doc.getElementById('drawer-cart-content'));

  /* re-read the cart after anything touches it */
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { refreshNudges(); }, function () {});
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) this.addEventListener('loadend', function () { refreshNudges(); });
    return _open.apply(this, arguments);
  };
  doc.addEventListener('cart:refresh', refreshNudges);
  doc.addEventListener('upcart:updated', refreshNudges);

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', refreshNudges); else refreshNudges();
})();
